'use client';
import Decimal from 'decimal.js';
import React from 'react';
import { Numeric } from '@/lib/types/common';
import { Text, TextProps } from '@/lib/ui-kit/text';
import { formatMoney } from '@/lib/utils/formatAmount';

type FloatTextProps<C extends React.ElementType = 'span'> = TextProps<C> & {
  value: Numeric; // a number between 0 and 1
  decimals?: number; // how many decimals to display in the cents
};

export function FloatText<C extends React.ElementType = 'span'>({
  value,
  decimals = 2,
  ...textProps
}: FloatTextProps<C>) {
  const val = Decimal(value).toDecimalPlaces(decimals);

  return (
    <Text<C> {...(textProps as TextProps<C>)}>
      {formatMoney(Number(val), { decimals: decimals })}
    </Text>
  );
}
